export default __webpack_public_path__ + "precision498f42.png";